// CMYK color type

export type CMYKColor = {
  a: number // alpha (0-1)
  c: number // cyan (0-1)
  k: number // key/black (0-1)
  m: number // magenta (0-1)
  y: number // yellow (0-1)
}
